import { User } from "../@core/data/users";

export default class Course {
  id?: string;
  title?: string;
  description?: string;
  purpose?: string;
  tags?: string[];
  coverUrl?: string;
  status?: number;

  authorName?: string;
  published?: boolean;
  publishedOn?: Date;
  privacy?: boolean;

  noSection?: number;
  noLecture?: number;
  noStudent?: number;

  noExercise?: number;
  noQuiz?: number;

  rating?: number;
  noRating?: number;
  noRating1?: number;
  noRating2?: number;
  noRating3?: number;
  noRating4?: number;
  noRating5?: number;

  noQnA?: number;
  noLiked?: number;
  noComment?: number;

  linkExerciseId?: string;

  hearts?: number;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
